<template>
  <b-modal id="customFieldValueEditModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.customField.create.header') }} ({{ parentTitle }})</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <CustomFieldValueForm :item="item"></CustomFieldValueForm>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <button type="submit" class="btn btn-success" @click="storeObject()">{{$t('buttons.save')}}</button>
          <b-button class="btn btn-secondary" @click="closeModal()">{{ closeText }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CustomFieldValueForm from '../CustomFieldValueForm'
export default {
  name: 'CustomFieldValueEditModal',
  components: {
    CustomFieldValueForm
  },
  data () {
    return {
      itemIndex: -1,
      routeName: '',
      closeText: this.$t('buttons.close'),
      parentTitle: '',
      item: {
        value: '',
        defaultValue: 0
      }
    }
  },
  created () {
    this.routeName = this.$route.name
  },
  computed: {
    show () {
      return this.$store.state.modals.customFieldValue.update.show
    },
    customFieldValueObject () {
      return this.$store.state.modals.customFieldValue.update.customFieldValueObject
    },
    index () {
      return this.$store.state.modals.customFieldValue.update.index
    }
  },
  watch: {
    show: function (val) {
      this.openModal()
    },
    customFieldObject: function (val) {
      this.openModal()
    },
    index: function (val) {
      this.openModal()
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && Object.entries(this.customFieldValueObject).length > 0 && this.index > -1) {
        this.item = Object.assign({}, this.$store.state.modals.customFieldValue.update.customFieldValueObject)
        this.itemIndex = this.$store.state.modals.customFieldValue.update.index
        this.$store.state.modals.customFieldValue.update.show = 0
        this.$store.state.modals.customFieldValue.update.customFieldValueObject = {}
        this.$store.state.modals.customFieldValue.update.index = -1
        this.$bvModal.show('customFieldValueEditModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('customFieldValueEditModal')
    },
    resetData () {
      this.item = {
        value: '',
        defaultValue: 0
      }
    },
    storeObject () {
      if (this.routeName === 'EXCMCaseTypeCreate' || this.routeName === 'EXCMTaskTypeCreate') {
        this.$store.state.modals.customFieldValue.update.customFieldValueObjectUpdated = this.item
        this.$store.state.modals.customFieldValue.update.indexUpdated = this.itemIndex
      }
      this.closeModal()
    }
  }
}
</script>
